module.exports = __webpack_public_path__ + "img/boca_fresca.64202260.png";